import React from "react";
import { HashLink as Link } from "react-router-hash-link";
import withProfile from "../utils/withProfile";
import ProfilePopup from "../components/ProfilePopup";
import { getUserAvatarUrl } from "../firebase/storage";
require("../home.css");
const tarifs = require("../constants/tarifs.json");

class PageLanding extends React.Component {
  constructor(props) {
    super(props);
    this.state = { showProfilePopup: false };
  }

  render() {
    const { profile, history } = this.props;

    return (
      <div className="PageLanding">
        <div className="BackgroundImage">
          <div class="video-background">
            <div class="video-foreground">
              <video autoPlay loop>
                <source
                  src={require("../media/home/Blurry_Trees_.mov")}
                  type="video/mp4"
                />
              </video>
            </div>
          </div>
          <div className="FirstScaffCTA">
            <p>Uelstudios Freeway, gemeinsam größer denken</p>
            <a href="http://uelstudios.de">
              <Button>Mehr</Button>
            </a>
          </div>

          <Link
            to="#product"
            scroll={el =>
              el.scrollIntoView({ behavior: "smooth", block: "start" })
            }
          >
            <i className="fas fa-chevron-down" />
          </Link>
        </div>
        <LandingHeader profile={profile} history={history} />

        <a class="anchor" id="product" />
        <img
          src={require("../media/home/demo1.png")}
          style={{ width: "100%" }}
        />
        <img
          src={require("../media/home/demo2.jpg")}
          style={{ width: "100%" }}
        />

        <img
          src={require("../media/home/demo3.jpg")}
          style={{ width: "100%" }}
        />
        {/*
        <div className="MainBody">
          <div className="TwoCols">
            <a class="anchor" id="product" />
            <div className="TwoColsChild">
              <h2>Was ist Uelstudios Freeway?</h2>
              <p>
                Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed
                diam nonumy eirmod tempor invidunt ut labore et dolore magna
                aliquyam erat, sed diam voluptua. At vero eos et accusam et
                justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea
                takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum
                dolor sit amet, consetetur sadipscing elitr, sed diam nonumy
                eirmod tempor invidunt ut labore et dolore magna aliquyam erat,
                sed diam voluptua. At vero eos et accusam et justo duo dolores
                et ea rebum.
              </p>
              <Button small>Features</Button>
            </div>
            <div className="TwoColsSpacer" />
            <div className="TwoColsChild">
              <h2>Wür wen ist Freeway?</h2>
              <p>
                Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed
                diam nonumy eirmod tempor invidunt ut labore et dolore magna
                aliquyam erat, sed diam voluptua. At vero eos et accusam et
                justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea
                takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum
                dolor sit amet, consetetur sadipscing elitr, sed diam nonumy
                eirmod tempor invidunt ut labore et dolore magna aliquyam erat,
                sed diam voluptua. At vero eos et accusam et justo duo dolores
                et ea rebum.
              </p>
              <Button small>Preise</Button>
            </div>
          </div>
          <div className="EasySteps">
            <a class="anchor" id="features" />
            Features
            <div className="Step">
              <p id="StepNumber">1</p>
              <p>
                <strong>Cloud Speicher</strong> Ihre Daten werden ganz
                unkompliziert in der Cloud gespeiert. Dabei garantieren wir eine
                Uptime von 99,999%
              </p>
              <img src={require("../media/home/feature_cloud.png")} />
            </div>
            <div className="Step">
              <p id="StepNumber">2</p>
              <p>
                <strong>Teams</strong> Unsere Software funktioniert super für
                einzelne Nutzer aber auch für riesige Teams.
              </p>
              <img src={require("../media/home/feature_cloud.png")} />
            </div>
            <div className="Step">
              <p id="StepNumber">3</p>
              <p>
                <strong>Branding</strong> Sie haben die Möglichkeit, die
                Erfahrung für Ihre Kunden perfekt anzupassen. So können Sie zum
                Beispiel ganz unkompliziert E-Mails im Look Ihres Unternehmes
                versenden.
              </p>
              <img src={require("../media/home/feature_cloud.png")} />
            </div>
          </div>
          <div className="Tarifs">
            <a class="anchor" id="tarifs" />
            {TarifItem(tarifs[0])} {TarifItem(tarifs[1])} {TarifItem(tarifs[2])}
          </div>
        </div>

        <div className="Footer" />
*/}
      </div>
    );
  }
}

export default withProfile(PageLanding);

function Button(props) {
  const isSmall = props.small ? true : false;

  const classes = `LandingCtaButton${isSmall ? "-Small" : ""}`;

  return (
    <div className={classes} onClick={props.onClick ? props.onClick : null}>
      {props.children}
    </div>
  );
}

function TarifItem(tarif) {
  const { title, slogan, good, bad } = tarif;

  const goodItems = good.map(row => {
    return (
      <div className="TarifItemRow">
        <p>{row}</p>
        <i className="fas fa-check" />
      </div>
    );
  });

  const badItems = bad.map(row => {
    return (
      <div className="TarifItemRowBad">
        <p>{row}</p>
        <i className="fas fa-times" />
      </div>
    );
  });

  return (
    <div className="TarifItem">
      <div id="Header">
        <p id="Title">{title}</p>
        <p id="Desc">{slogan}</p>
      </div>
      {goodItems}
      {badItems}
    </div>
  );
}

export class LandingHeader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showProfilePopup: false,
      userAvatar: undefined,
      showMenu: false
    };
  }

  componentWillReceiveProps(props, state) {
    const { userAvatar } = this.state;

    if (props.profile && userAvatar === undefined) {
      this.setState({ userAvatar: null });
      getUserAvatarUrl(
        props.profile.id,
        url => {
          this.setState({ userAvatar: url });
        },
        error => {}
      );
    }
  }

  toggleMenu() {
    this.setState({ showMenu: !this.state.showMenu });
  }

  render() {
    const { userAvatar, showProfilePopup, showMenu } = this.state;
    const { profile, history } = this.props;
    const isLoggedIn = profile;

    const menu = (
      <div className="HeaderNavPanel">
        <Link
          to="#product"
          scroll={el =>
            el.scrollIntoView({ behavior: "smooth", block: "start" })
          }
        >
          Produkt
        </Link>
        <Link
          to="#features"
          scroll={el =>
            el.scrollIntoView({ behavior: "smooth", block: "start" })
          }
        >
          Features
        </Link>
        <Link
          to="#tarifs"
          scroll={el =>
            el.scrollIntoView({ behavior: "smooth", block: "start" })
          }
        >
          Preise
        </Link>
        <Link
          to="#contact"
          scroll={el =>
            el.scrollIntoView({ behavior: "smooth", block: "start" })
          }
        >
          Kontakt
        </Link>
        {isLoggedIn ? (
          <a href="./dash" className="GotoDashboard">
            <i className="fas fa-external-link-square-alt" />
          </a>
        ) : null}

        {isLoggedIn ? (
          <div style={{ position: "relative" }}>
            <img
              className="HeaderProfilePicture"
              src={require("../media/Placeholder-Profilepicture.jpg")}
              onClick={() => this.setState({ showProfilePopup: true })}
            />
            <ProfilePopup
              landingPageStyle
              avatar={userAvatar}
              profile={profile}
              show={showProfilePopup}
              history={history}
              onSignOut={() => window.location.reload()}
              onClose={() => this.setState({ showProfilePopup: false })}
            />
          </div>
        ) : (
          <a href="./login" className="RoundBtn">
            Anmelden
          </a>
        )}
      </div>
    );

    return (
      <div className="LandingHeader">
        <div className="HeaderInner">
          <Link to="/">
            <img src={require("../media/Freeway-Logo.png")} />
          </Link>
          <i
            className="fas fa-bars HeaderExpandButton"
            onClick={() => this.toggleMenu()}
          />
          {menu}
        </div>
        <div
          className={`HeaderBottomExpandPanel${
            showMenu ? "" : " HeaderBottomExpandPanelHidden"
          }`}
        >
          {menu}
        </div>
      </div>
    );
  }
}

/*

<Link to="/dash/">
          <p className="Link">Zum Uelstudios Freeway Dashboard</p>
        </Link>
        <a href="http://www.uelstudios.de">
          <p className="Link">Zu Uelstudios</p>
        </a>

*/



// WEBPACK FOOTER //
// ./src/pages/PageLanding.js